/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface PersonReferral
 */
export interface PersonReferralOptional {
  /**
   *
   * @type {number}
   * @memberof PersonReferral
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof PersonReferral
   */
  referralSource?: string;
}

export interface PersonReferral extends PersonReferralOptional {
  /**
   *
   * @type {number}
   * @memberof PersonReferral
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof PersonReferral
   */
  referralSource?: string;
}

export interface PersonReferralTrackedI {
  /**
   *
   * @type {number}
   * @memberof PersonReferral
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonReferral
   */
  referralSource?: string;
  referralSourceIsSet: boolean;
}

transformDatesMap.set("PersonReferral", function (model: PersonReferral) {});

export type PersonReferralMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  referralSource: PropertyMeta<MetaTypeBase<string>>;
}>;

export var PersonReferralMeta: PersonReferralMetaI = {} as PersonReferralMetaI;
PersonReferralMeta = typeMeta("PersonReferral", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  referralSource: propertyMeta(
    "referralSource",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = PersonReferralMeta;

registerMeta(() => {});

export class PersonReferralTracked implements PersonReferralTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  referralSource__I?: string = undefined;
  referralSourceIsSet: boolean = false;
  set referralSource(v: undefined | string) {
    if (v !== undefined) {
      this.referralSource__I = v;
      this.referralSourceIsSet = true;
    } else {
      this.referralSource__I = v || undefined;
      this.referralSourceIsSet = false;
    }
    this.changeTracker = true;
  }
  get referralSource() {
    return this.referralSource__I;
  }
  constructor(config?: PersonReferralOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: PersonReferralOptional,
    options?: AssignOptions,
  ): PersonReferralTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.referralSource &&
      this.referralSourceApplyFilter(optionsRequired.filter)
    ) {
      this.referralSource = config.referralSource;
      if (optionsRequired.unassign) this.referralSourceIsSet = false;
      else this.referralSourceIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonReferralTrackedI {
    const cloned = {} as PersonReferralTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.referralSourceIsSetDeep() &&
      this.referralSourceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.referralSourceIsSet = true;
      cloned.referralSource = this.referralSource;
    } else {
      //cloned.referralSourceIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonReferralTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.referralSourceApplyFilter(filter))
      this.referralSourceIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonReferralMeta.assignId,
      PersonReferralMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  referralSourceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonReferralMeta.referralSource,
      PersonReferralMeta,
      this.referralSource,
      this,
    );
  }
  referralSourceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.referralSourceIsSet && this.referralSourceApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.referralSourceIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
